import { render } from "./CollapsibleSection.vue?vue&type=template&id=4dc15964&scoped=true&ts=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=ts"
export * from "./CollapsibleSection.vue?vue&type=script&lang=ts"

import "./CollapsibleSection.vue?vue&type=style&index=0&id=4dc15964&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc15964"]])

export default __exports__